export default __webpack_public_path__ + "static/media/image2pro7.db9c3821.jpeg";